<template>
  <div class="c_table_wrap">
    <table>
      <colgroup>
        <col width="200px;">
        <col width="">
      </colgroup>
      <tr>
        <td class="c_t_title">
          작성일
        </td>
        <td class="">
          <div class="filter-select-div el-filter-date pt0 pb0">

                        <span class="filter-select-div el-filter-date">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                            class="el-date-common el-date-month"
                            v-model="date"
                            prefix-icon=" "
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            placeholder="작성일"
                            @change="parentChange('date',date)"
                            clear-icon="none"
                            :picker-options="pickerOptions"
                        ></el-date-picker>
                        </span>
            <div class="input_error">{{ validation.firstError('date') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">
          제목
        </td>
        <td>
          <div>
            <el-input v-model="title" maxlength="40" @input="parentChange('title', title)"></el-input>
            <div class="input_error">{{ validation.firstError('title') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">
          이미지
        </td>
        <td>
          <div class="banner_upload">
            <div class="input_error pt0 pb0 mb10">Pc에서 노출되는 이미지입니다. 크기는 1100 x 460 에 최적화 되어있습니다.</div>
            <div class="l_banner_upload" @click="changeType('files')">
              <el-upload
                  class="avatar-uploader"
                  :auto-upload="false"
                  action=""
                  :show-file-list="false"
                  list-type="picture"
                  :file-list="files"
                  :on-change="onlyOnePhotoChange"
              >
                <img class="pc_banner" v-if="hasFile('files')" :src="files[0].org_url">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div class="input_error">{{ validation.firstError('files') }}</div>
          </div>

          <div class="banner_upload">
            <div class="input_error pt0 pb0 mb10">Mobile에서 노출되는 이미지입니다. 크기는 710 x 566 에 최적화 되어있습니다.</div>
            <div class="l_banner_upload" @click="changeType('filesM')">
              <el-upload
                  class="avatar-uploader"
                  :auto-upload="false"
                  action=""
                  :show-file-list="false"
                  list-type="picture"
                  :file-list="filesM"
                  :on-change="onlyOnePhotoChange"
              >
                <img class="mobile_banner" v-if="hasFile('filesM')" :src="filesM[0].org_url">
                <i v-else class="el-icon-plus avatar-uploader-icon banner_mobile"></i>
              </el-upload>
            </div>
            <div class="input_error">{{ validation.firstError('filesM') }}</div>
          </div>
        </td>


      </tr>
      <tr>
        <td class="c_t_title">
          링크 사용여부
        </td>
        <td>
          <el-radio-group v-model="isDisplay" @change="parentChange('isDisplay', isDisplay)">
            <el-radio :label="1">사용</el-radio>
            <el-radio :label="0">미사용</el-radio>
          </el-radio-group>
        </td>
      </tr>
      <tr v-if="isDisplay === 1">
        <td class="c_t_title">
          웹링크
        </td>
        <td>
          <div>
            <el-input v-model="url" maxlength="100" @input="parentChange('url', url)"></el-input>
            <div class="input_error">{{ validation.firstError('url') }}</div>
          </div>
        </td>
      </tr>

    </table>


  </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import bannerValidator from "@/mixins/validators/bannerValidator";
import elFileMixins from "@/mixins/elFileMixins";
import imageOption from "@/mixins/imageOption";

export default {
  name: "BannerWriteDefaultLayout",
  mixins: [alertMixins, bannerValidator, elFileMixins, imageOption],
  components: {},
  inject: {
    bannerWriteSetData: {
      default: () => {
      }
    },
  },
  provide() {
    return {}
  },
  props: {
    bannerData: {
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      date: '',
      pickerOptions: { //데이트피커 옵션
        disabledDate(time) {
          let nowDate = new Date();
          return time.getTime() > nowDate;
        },
      },
      filesM: [],
    }
  },
  created() {
  },
  mounted() {
    if (this.hasBannerData()) {
      this.initSetData();
    }
    EventBus.$on('BannerWriteDefaultLayoutValidator', this.checkValidator);

  },
  beforeDestroy() {
    EventBus.$off('BannerWriteDefaultLayoutValidator')
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initSetData() {
      this.title = this.bannerData.b_subject;
      this.parentChange('title', this.title);
      this.isDisplay = this.bannerData.b_link;
      this.parentChange('isDisplay', this.isDisplay);
      this.date = this.bannerData.b_date;
      this.parentChange('date', this.date);
      this.url = this.bannerData.b_url;
      this.parentChange('url', this.url);

      if (!util.isEmpty(this.bannerData.Files)) {
        this.bannerData.Files[0].url = this.bannerData.Files[0].org_url;
        this.files = this.bannerData.Files
        this.parentChange('files', this.files);
      }
      if (!util.isEmpty(this.bannerData.MobileFiles)) {
        this.bannerData.MobileFiles[0].url = this.bannerData.MobileFiles[0].org_url;
        this.filesM = this.bannerData.MobileFiles
        this.parentChange('filesM', this.filesM);
      }

    },

    hasBannerData() {
      return !util.isEmpty(this.bannerData) && !util.isEmpty(this.bannerData.b_idx);
    },
    hasFile(typeName) {
      if (this.hasOwnProperty(typeName) && !util.isEmpty(this[typeName]) && this[typeName][0].hasOwnProperty('org_url')) {
        return true;
      }
      return false;
    },
    checkValidator(dataArr) {
      this.$validate(dataArr)
    },
    parentChange(key, value) {
      this.bannerWriteSetData(key, value)
    },

  },
  watch: {},
}
</script>

<style scoped>

</style>
